import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tod-batch-promotion" }
const _hoisted_2 = { class: "tod-batch-promotion__row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "tod-batch-promotion__label" }, "新促销类型", -1)
const _hoisted_4 = { class: "tod-batch-promotion__tip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_button = _resolveComponent("oio-button")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_oio_modal = _resolveComponent("oio-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_oio_button, {
      type: "primary",
      onClick: _ctx.openModal
    }, {
      default: _withCtx(() => [
        _createTextVNode("批量修改促销类型")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_oio_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
      title: "批量修改促销类型",
      width: "small"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_oio_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_oio_button, {
          type: "primary",
          loading: _ctx.confirmLoading,
          onClick: _ctx.onConfirm
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_a_select, {
            class: "oio-select",
            "dropdown-class-name": "oio-select-dropdown",
            value: _ctx.targetType,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.targetType) = $event)),
            placeholder: "请选择促销类型",
            style: {"width":"320px"},
            "show-search": "",
            "option-filter-prop": "label",
            "default-active-first-option": false,
            options: _ctx.promotionTypeOptions
          }, null, 8, ["value", "options"])
        ]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.tip), 1)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}